// Corevian Executive Demo — simulated workforce dataset
// SAFETY: fictional presentation data only. Never connected to production
// Corevian University personnel, learner, or qualification records.
//
// DATA RECONCILIATION (approved decision, see conversation record):
// Source data contained two "Morgan Reed" records with identical fields
// except status/competency/field/authorization. Record A (NOT AUTHORIZED)
// is the sole Morgan Reed and is preserved exactly as supplied. Record B
// (previously the conflicting READY/AUTHORIZED duplicate) keeps its exact
// qualification state but has been given a new, unused fictional identity
// -- "Devon Whitfield" -- so it can never be confused with Morgan Reed
// during a live presentation. Every record carries a stable id; all
// lookups use id, never name.

window.COREVIAN_DEMO_WORKFORCE = [
  {
    "name": "Jordan Ellis",
    "status": "READY FOR ASSIGNMENT",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 1
  },
  {
    "name": "Morgan Reed",
    "status": "NOT AUTHORIZED",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "NOT QUALIFIED",
    "field": "NOT READY",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 2
  },
  {
    "name": "Jordan Brooks",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Pharmaceutical Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 3
  },
  {
    "name": "Jordan Carter",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Medical Device Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 4
  },
  {
    "name": "Jordan Davis",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Blood Product Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 5
  },
  {
    "name": "Jordan Foster",
    "status": "READY FOR ASSIGNMENT",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 6
  },
  {
    "name": "Jordan Grant",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Lab Specimen Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 7
  },
  {
    "name": "Jordan Hayes",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Pharmaceutical Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 8
  },
  {
    "name": "Jordan Irving",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Medical Device Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 9
  },
  {
    "name": "Jordan James",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Blood Product Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 10
  },
  {
    "name": "Jordan King",
    "status": "READY FOR ASSIGNMENT",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 11
  },
  {
    "name": "Jordan Lewis",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Lab Specimen Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 12
  },
  {
    "name": "Jordan Moore",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Pharmaceutical Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 13
  },
  {
    "name": "Jordan Nelson",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Medical Device Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 14
  },
  {
    "name": "Morgan Ellis",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Blood Product Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 15
  },
  {
    "name": "Devon Whitfield",
    "status": "READY FOR ASSIGNMENT",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 16
  },
  {
    "name": "Morgan Brooks",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Lab Specimen Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 17
  },
  {
    "name": "Morgan Carter",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Pharmaceutical Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 18
  },
  {
    "name": "Morgan Davis",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Medical Device Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 19
  },
  {
    "name": "Morgan Foster",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Blood Product Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 20
  },
  {
    "name": "Morgan Grant",
    "status": "READY FOR ASSIGNMENT",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 21
  },
  {
    "name": "Morgan Hayes",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Lab Specimen Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 22
  },
  {
    "name": "Morgan Irving",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Pharmaceutical Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 23
  },
  {
    "name": "Morgan James",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Medical Device Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 24
  },
  {
    "name": "Morgan King",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Blood Product Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 25
  },
  {
    "name": "Morgan Lewis",
    "status": "READY FOR ASSIGNMENT",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 26
  },
  {
    "name": "Morgan Moore",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Lab Specimen Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 27
  },
  {
    "name": "Morgan Nelson",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Pharmaceutical Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 28
  },
  {
    "name": "Avery Ellis",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Medical Device Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 29
  },
  {
    "name": "Avery Reed",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Blood Product Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 30
  },
  {
    "name": "Avery Brooks",
    "status": "READY FOR ASSIGNMENT",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 31
  },
  {
    "name": "Avery Carter",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Lab Specimen Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 32
  },
  {
    "name": "Avery Davis",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Pharmaceutical Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 33
  },
  {
    "name": "Avery Foster",
    "status": "READY FOR ASSIGNMENT",
    "scope": "Medical Device Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "CURRENT",
    "id": 34
  },
  {
    "name": "Avery Grant",
    "status": "ACTION REQUIRED",
    "scope": "Blood Product Transport",
    "training": "PASS",
    "competency": "REASSESSMENT REQUIRED",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 35
  },
  {
    "name": "Avery Hayes",
    "status": "ACTION REQUIRED",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "PENDING",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 36
  },
  {
    "name": "Avery Irving",
    "status": "ACTION REQUIRED",
    "scope": "Lab Specimen Transport",
    "training": "PASS",
    "competency": "REASSESSMENT REQUIRED",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 37
  },
  {
    "name": "Avery James",
    "status": "ACTION REQUIRED",
    "scope": "Pharmaceutical Transport",
    "training": "PASS",
    "competency": "PENDING",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 38
  },
  {
    "name": "Avery King",
    "status": "ACTION REQUIRED",
    "scope": "Medical Device Transport",
    "training": "PASS",
    "competency": "REASSESSMENT REQUIRED",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 39
  },
  {
    "name": "Avery Lewis",
    "status": "ACTION REQUIRED",
    "scope": "Blood Product Transport",
    "training": "PASS",
    "competency": "PENDING",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 40
  },
  {
    "name": "Avery Moore",
    "status": "ACTION REQUIRED",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "REASSESSMENT REQUIRED",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 41
  },
  {
    "name": "Avery Nelson",
    "status": "ACTION REQUIRED",
    "scope": "Lab Specimen Transport",
    "training": "PASS",
    "competency": "PENDING",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 42
  },
  {
    "name": "Taylor Ellis",
    "status": "ACTION REQUIRED",
    "scope": "Pharmaceutical Transport",
    "training": "PASS",
    "competency": "REASSESSMENT REQUIRED",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 43
  },
  {
    "name": "Taylor Reed",
    "status": "NOT AUTHORIZED",
    "scope": "Medical Device Transport",
    "training": "PASS",
    "competency": "NOT QUALIFIED",
    "field": "NOT READY",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 44
  },
  {
    "name": "Taylor Brooks",
    "status": "NOT AUTHORIZED",
    "scope": "Blood Product Transport",
    "training": "PASS",
    "competency": "NOT QUALIFIED",
    "field": "NOT READY",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 45
  },
  {
    "name": "Taylor Carter",
    "status": "NOT AUTHORIZED",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "NOT QUALIFIED",
    "field": "NOT READY",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 46
  },
  {
    "name": "Taylor Davis",
    "status": "NOT AUTHORIZED",
    "scope": "Lab Specimen Transport",
    "training": "PASS",
    "competency": "NOT QUALIFIED",
    "field": "NOT READY",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 47
  },
  {
    "name": "Taylor Foster",
    "status": "NOT AUTHORIZED",
    "scope": "Pharmaceutical Transport",
    "training": "PASS",
    "competency": "NOT QUALIFIED",
    "field": "NOT READY",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 48
  },
  {
    "name": "Taylor Grant",
    "status": "NOT AUTHORIZED",
    "scope": "Medical Device Transport",
    "training": "PASS",
    "competency": "NOT QUALIFIED",
    "field": "NOT READY",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 49
  },
  {
    "name": "Taylor Hayes",
    "status": "RENEWAL DUE",
    "scope": "Blood Product Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "DUE SOON",
    "id": 50
  },
  {
    "name": "Taylor Irving",
    "status": "RENEWAL DUE",
    "scope": "General Clinical Courier",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "DUE SOON",
    "id": 51
  },
  {
    "name": "Taylor James",
    "status": "RENEWAL DUE",
    "scope": "Lab Specimen Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "DUE SOON",
    "id": 52
  },
  {
    "name": "Taylor King",
    "status": "RENEWAL DUE",
    "scope": "Pharmaceutical Transport",
    "training": "PASS",
    "competency": "QUALIFIED",
    "field": "READY",
    "documents": "CURRENT",
    "authorization": "AUTHORIZED",
    "renewal": "DUE SOON",
    "id": 53
  },
  {
    "name": "Taylor Lewis",
    "status": "TRAINING INCOMPLETE",
    "scope": "Medical Device Transport",
    "training": "INCOMPLETE",
    "competency": "PENDING",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 54
  },
  {
    "name": "Taylor Moore",
    "status": "TRAINING INCOMPLETE",
    "scope": "Blood Product Transport",
    "training": "INCOMPLETE",
    "competency": "PENDING",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 55
  },
  {
    "name": "Taylor Nelson",
    "status": "TRAINING INCOMPLETE",
    "scope": "General Clinical Courier",
    "training": "INCOMPLETE",
    "competency": "PENDING",
    "field": "PENDING",
    "documents": "CURRENT",
    "authorization": "NOT AUTHORIZED",
    "renewal": "CURRENT",
    "id": 56
  }
];